export var SMALL_MOBILE_IMAGE_RESIZE_WIDTH = 320;
export var MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH = 480;
export var LARGE_MOBILE_IMAGE_RESIZE_WIDTH = 640;
export var DESKTOP_IMAGE_RESIZE_WIDTH = 1024;
export var WIDE_SCREEN_IMAGE_RESIZE_WIDTH = 1600;
export var STICKY_FOOTER_SCROLL_THRESHOLD = 100;
export var getImageUrl = function (format, image) {
    var src = (image || {}).src;
    var _getResizedImageUrl = function (width) { return getResizedImageUrl(src, width); };
    switch (format) {
        case 'small-mobile':
            return _getResizedImageUrl(SMALL_MOBILE_IMAGE_RESIZE_WIDTH);
        case 'medium-mobile':
            return _getResizedImageUrl(MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH);
        case 'large-mobile':
            return _getResizedImageUrl(LARGE_MOBILE_IMAGE_RESIZE_WIDTH);
        case 'desktop':
            return _getResizedImageUrl(DESKTOP_IMAGE_RESIZE_WIDTH);
        default:
            return _getResizedImageUrl(WIDE_SCREEN_IMAGE_RESIZE_WIDTH);
    }
};
export var getResizedImageUrl = function (imageUrl, width) {
    if (!imageUrl) {
        return null;
    }
    var url = new URL(imageUrl);
    url.searchParams.set('imwidth', width.toString());
    return url.toString();
};
